import Button from '@mui/material/Button';
import { signOut } from 'aws-amplify/auth';
import { ThemeProvider } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import theme from '@/theme.ts';
import log from 'loglevel';

export default function LogoutButton() {
  const handleLogout = async () => {
    try {
      await signOut({ global: true });
      window.location.href = '/logout.html';
    } catch (error) {
      log.error('Error occurred during logout:', error);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Button
        sx={{
          color: theme.palette.primary.contrastText,
          borderColor: theme.palette.primary.contrastText,
          fontSize: 16,
          fontWeight: 700,
          textTransform: 'none',
        }}
        variant="outlined"
        endIcon={<LogoutIcon />}
        onClick={handleLogout}
      >
        Logout
      </Button>
    </ThemeProvider>
  );
}
